package org.catharsis.spendtel.feature.data

import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.Serializable

@Serializable
data class ExpenseReportDocument(
    val status: String = "processing",
    val createdAt: Timestamp? = null,
    val updatedAt: Timestamp? = null,
    val sourceDocuments: List<SourceDocument> = emptyList(),
    val error: String? = null,
    val summary: ReportSummary? = null,
    val monthlyStory: MonthlyStory? = null,
    val lifeCategories: List<LifeCategory> = emptyList(),
    val financialPersonality: FinancialPersonality? = null,
    val merchantInsights: List<MerchantInsight> = emptyList(),
    val spendingTimeline: List<TimelineEntry> = emptyList(),
    val whatChanged: WhatChanged? = null,
    val aboutYou: List<String> = emptyList(),
    val spendingStories: List<SpendingStory> = emptyList(),
    val transactions: List<Transaction> = emptyList(),
    val financialGoalUsed: String? = null,
    val equivalences: List<SpendingEquivalence> = emptyList(),
    val goalInsights: List<GoalInsight> = emptyList(),
    val spendingPatterns: SpendingPatterns? = null,
    val trends: ReportTrends? = null,
    val moneyLeaks: MoneyLeaks? = null,
    val highlights: List<String> = emptyList(),
)

fun Timestamp.toEpochMilliseconds(): Long = seconds * 1_000 + nanoseconds / 1_000_000

fun ExpenseReportDocument.toExpenseReport(id: String): ExpenseReport {
    return ExpenseReport(
        id = id,
        status = status,
        createdAtMillis = createdAt?.toEpochMilliseconds() ?: 0L,
        sourceDocuments = sourceDocuments,
        error = error,
        summary = summary,
        monthlyStory = monthlyStory,
        lifeCategories = lifeCategories,
        financialPersonality = financialPersonality,
        merchantInsights = merchantInsights,
        spendingTimeline = spendingTimeline,
        whatChanged = whatChanged,
        aboutYou = aboutYou,
        spendingStories = spendingStories,
        transactions = transactions,
        financialGoalUsed = financialGoalUsed,
        equivalences = equivalences,
        goalInsights = goalInsights,
        spendingPatterns = spendingPatterns,
        trends = trends,
        moneyLeaks = moneyLeaks,
        highlights = highlights,
    )
}
